import { isFeatureEnabled } from 'owa-feature-flags';
import {
    getOptionsForFeature,
    OwsOptionsFeatureType,
    BohemiaOptions,
} from 'owa-outlook-service-options';

export enum PragueEnabledScenario {
    ReadingPane,
    Compose,
}

export default function isPragueEnabled(scenario: PragueEnabledScenario): boolean {
    if (getOptionsForFeature<BohemiaOptions>(OwsOptionsFeatureType.Bohemia).bohemiaEnabled) {
        switch (scenario) {
            case PragueEnabledScenario.ReadingPane:
                return isFeatureEnabled('rp-prague');
            case PragueEnabledScenario.Compose:
                return isFeatureEnabled('cmp-prague');
        }
    }
    return false;
}
